import { render, staticRenderFns } from "./PUdetails.vue?vue&type=template&id=2d04ab9c&scoped=true&"
import script from "./PUdetails.vue?vue&type=script&lang=js&"
export * from "./PUdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d04ab9c",
  null
  
)

export default component.exports